import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faWarning } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import styles from './ErrorNotice.module.scss';
import Icon from './Icon';
import { Text } from '@mantine/core';
import classNames from 'classnames';
export default function ErrorNotice(param) {
    var children = param.children, className = param.className;
    if (children == null) {
        return null;
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames(styles.errorNotice, className),
        children: [
            /*#__PURE__*/ _jsx(Icon, {
                className: styles.errorNoticeIcon,
                icon: faWarning
            }),
            /*#__PURE__*/ _jsx(Text, {
                className: styles.errorNoticeText,
                size: "sm",
                children: children
            })
        ]
    });
}
